import {getCollectionQuizSession, QuizSessionDb} from '@cp/model';
import {collection, CollectionReference} from 'firebase/firestore';
import {firebaseFirestore} from '../../config/firebase';

export default function getQuizSessionCollection(uid: string): CollectionReference<QuizSessionDb> {
  return collection(firebaseFirestore, getCollectionQuizSession(uid)) as CollectionReference<QuizSessionDb>;
}
